import { MoneyModel, timeModel } from "./..";
import { PayoutIntegrationModel } from "../PayoutIntegrationModel";
import Decimal from 'decimal.js';
import { InvoiceIntegrationModel } from "../InvoiceIntegrationModel";
export let PayoutStatus = /*#__PURE__*/function (PayoutStatus) {
  PayoutStatus["Paid"] = "paid";
  PayoutStatus["Failed"] = "failed";
  return PayoutStatus;
}({});
export let PayoutFailureCode = /*#__PURE__*/function (PayoutFailureCode) {
  PayoutFailureCode["InvalidAccountNumber"] = "invalid_account_number";
  PayoutFailureCode["BankAccountRestricted"] = "bank_account_restricted";
  PayoutFailureCode["AccountClosed"] = "account_closed";
  PayoutFailureCode["NoAccount"] = "no_account";
  PayoutFailureCode["DebitNotAuthorized"] = "debit_not_authorized";
  PayoutFailureCode["InsufficientFunds"] = "insufficient_funds";
  PayoutFailureCode["AccountFrozen"] = "account_frozen";
  PayoutFailureCode["RefusedByReceiver"] = "refused_by_receiver";
  PayoutFailureCode["MissingAuthorization"] = "missing_authorization";
  return PayoutFailureCode;
}({});
export let PayoutInvoiceType = /*#__PURE__*/function (PayoutInvoiceType) {
  PayoutInvoiceType["Payment"] = "Payment";
  PayoutInvoiceType["Refund"] = "Refund";
  PayoutInvoiceType["Dispute"] = "Dispute";
  return PayoutInvoiceType;
}({});
export class PayoutModel {
  static fromDTO(dto) {
    return new PayoutModel({
      id: dto.id,
      createdAt: dto.createdAt,
      amount: MoneyModel.fromDTO(dto.amount),
      status: dto.status,
      invoices: dto.invoices.map(PayoutModel.fromPayoutInvoiceDTO),
      integration: dto.integration && PayoutIntegrationModel.fromDTO(dto.integration),
      payoutFailure: dto.payoutFailure
    });
  }
  static fromPayoutInvoiceDTO(dto) {
    const zeroFee = new MoneyModel(new Decimal(0));
    const fee = dto.fee ? MoneyModel.fromDTO(dto.fee) : zeroFee;
    const processingFee = MoneyModel.fromDTO(dto.processingFee);
    const customerProcessingFee = MoneyModel.fromDTO(dto.customerProcessingFee);
    const disputeFee = MoneyModel.fromDTO(dto.disputeFee);
    const totalAmount = MoneyModel.fromDTO(dto.totalAmount);
    const depositAmount = MoneyModel.fromDTO(dto.depositAmount);
    const serviceFeeRefund = MoneyModel.fromDTO(dto.serviceFeeRefund);
    return {
      id: dto.id,
      type: dto.type,
      relationshipId: dto.relationshipId,
      createdOn: timeModel.toDate(dto.createdOn),
      dueDate: timeModel.toDate(dto.dueDate),
      number: dto.number,
      formattedNumber: dto.formattedNumber,
      title: dto.title,
      customer: dto.customer,
      fee,
      processingFee,
      customerProcessingFee,
      disputeFee,
      serviceFeeRefund,
      totalFees: fee.add(processingFee).add(customerProcessingFee).add(disputeFee).add(serviceFeeRefund),
      totalAmount: totalAmount,
      depositAmount: depositAmount,
      integration: dto.integration && InvoiceIntegrationModel.fromDTO(dto.integration, totalAmount.isZero())
    };
  }
  constructor(data) {
    this.data = data;
  }
  integration() {
    return this.data.integration;
  }
  isPaid() {
    return this.data.status === PayoutStatus.Paid;
  }
  isNotSynced() {
    return !!this.data.integration && !this.data.integration.isSynced();
  }
  isSynced() {
    return !!this.data.integration && this.data.integration.isSynced();
  }
  payoutFailure() {
    return this.data.payoutFailure;
  }
  amount() {
    return this.data.amount;
  }
  id() {
    return this.data.id;
  }
  createdAt() {
    return this.data.createdAt;
  }
  formattedCreatedAt() {
    return timeModel.formatDate(this.data.createdAt);
  }
  invoices() {
    return this.data.invoices;
  }
}